"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _loadScript = _interopRequireDefault(require("load-script"));

var _Success = require("../common/Success");

var _Extension = require("../common/Extension");

var _constants = require("../constants");

var GOOGLE_SDK_URL = "https://apis.google.com/js/api.js";
var GOOGLE_URL_FILES = "https://www.googleapis.com/drive/v2/files/{fileId}?alt=media";
var scriptLoadingStarted = false;

var GoogleChooser =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(GoogleChooser, _React$Component);

  function GoogleChooser(props) {
    var _this;

    (0, _classCallCheck2.default)(this, GoogleChooser);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(GoogleChooser).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onApiLoad", function () {
      window.gapi.load("auth");
      window.gapi.load("picker");
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isGoogleReady", function () {
      return !!window.gapi;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isGoogleAuthReady", function () {
      return !!window.gapi.auth;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isGooglePickerReady", function () {
      return !!window.google.picker;
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSelectedFiles", function (data) {
      var success = _this.props.success;

      if (data.action === window.google.picker.Action.PICKED) {
        var promiseList = [];
        var token = window.gapi.auth.getToken();
        var oauthToken = token && token.access_token;
        var headers = {
          method: "GET",
          headers: {
            Authorization: "Bearer ".concat(oauthToken)
          }
        };
        data.docs.forEach(function (doc) {
          promiseList.push(_this.getRequestFile(headers, doc));
        });
        Promise.all(promiseList).then(function (files) {
          if (success) {
            success(files);
          }
        }).catch(function (err) {
          console.error(err);
        });
      }
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getRequestFile",
    /*#__PURE__*/
    function () {
      var _ref = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(headers, doc) {
        var fileId, fileName, sizeBytes, fileBlob;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                fileId = doc.id, fileName = doc.name, sizeBytes = doc.sizeBytes; // THE MAPPING BETWEEN THE PROVIDER'S
                // RESPONSE AND THE OBJECT OF SUCCESS

                _context.next = 3;
                return fetch(GOOGLE_URL_FILES.replace("{fileId}", fileId), headers).then(function (response) {
                  if (response.ok) {
                    return response.blob();
                  }

                  return null;
                }).then(function (dataBlob) {
                  dataBlob.lastModifiedDate = new Date();
                  dataBlob.name = fileName;
                  var file = new _Success.Success(fileId, fileName, sizeBytes, null, _constants.PROVIDERS.GDRIVE, dataBlob);
                  return file;
                }).catch(function (error) {
                  console.error(error);
                });

              case 3:
                fileBlob = _context.sent;
                return _context.abrupt("return", fileBlob);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
    _this.onApiLoad = _this.onApiLoad.bind((0, _assertThisInitialized2.default)(_this));
    _this.onChoose = _this.onChoose.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(GoogleChooser, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.isGoogleReady()) {
        // google api is already exists
        // init immediately
        this.onApiLoad();
      } else if (!scriptLoadingStarted) {
        // load google api and the init
        scriptLoadingStarted = true;
        (0, _loadScript.default)(GOOGLE_SDK_URL, this.onApiLoad);
      }
    }
  }, {
    key: "onChoose",
    value: function onChoose() {
      var _this2 = this;

      var _this$props = this.props,
          disabled = _this$props.disabled,
          onAuthFailed = _this$props.onAuthFailed;

      if (!this.isGoogleReady() || !this.isGoogleAuthReady() || !this.isGooglePickerReady() || disabled) {
        return;
      }

      var token = window.gapi.auth.getToken();
      var oauthToken = token && token.access_token;

      if (oauthToken) {
        this.createPicker(oauthToken);
      } else {
        this.doAuth(function (response) {
          if (response.access_token) {
            _this2.createPicker(response.access_token);
          } else {
            onAuthFailed(response);
          }
        });
      }
    }
  }, {
    key: "doAuth",
    value: function doAuth(callback) {
      var _this$props2 = this.props,
          clientId = _this$props2.clientId,
          scope = _this$props2.scope,
          authImmediate = _this$props2.authImmediate;
      window.gapi.auth.authorize({
        client_id: clientId,
        scope: scope,
        immediate: authImmediate
      }, callback);
    }
  }, {
    key: "createPicker",
    value: function createPicker(oauthToken) {
      var _this$props3 = this.props,
          onAuthenticate = _this$props3.onAuthenticate,
          createPicker = _this$props3.createPicker,
          viewId = _this$props3.viewId,
          extensions = _this$props3.extensions,
          query = _this$props3.query,
          developerKey = _this$props3.developerKey,
          origin = _this$props3.origin,
          navHidden = _this$props3.navHidden,
          multiselect = _this$props3.multiselect;
      onAuthenticate(oauthToken);

      if (createPicker) {
        return createPicker(window.google, oauthToken);
      }

      var googleViewId = window.google.picker.ViewId[viewId];
      var view = new window.google.picker.View(googleViewId);

      if (extensions) {
        var ext = (0, _Extension.getExtensions)(_constants.PROVIDERS.GDRIVE, extensions);
        view.setMimeTypes(ext.join(","));
      }

      if (query) {
        view.setQuery(query);
      }

      if (!view) {
        throw new Error("Can't find view by viewId");
      }

      var picker = new window.google.picker.PickerBuilder().addView(view).setOAuthToken(oauthToken).setDeveloperKey(developerKey).setCallback(this.onSelectedFiles);

      if (origin) {
        picker.setOrigin(origin);
      }

      if (navHidden) {
        picker.enableFeature(window.google.picker.Feature.NAV_HIDDEN);
      }

      if (multiselect) {
        picker.enableFeature(window.google.picker.Feature.MULTISELECT_ENABLED);
      }

      picker.build().setVisible(true);
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return _react.default.createElement("div", {
        onClick: this.onChoose
      }, children || _react.default.createElement("div", null, "Open google chooser"));
    }
  }]);
  return GoogleChooser;
}(_react.default.Component);

GoogleChooser.propTypes = {
  children: _propTypes.default.node,
  clientId: _propTypes.default.string.isRequired,
  developerKey: _propTypes.default.string.isRequired,
  scope: _propTypes.default.array,
  viewId: _propTypes.default.string,
  authImmediate: _propTypes.default.bool,
  origin: _propTypes.default.string,
  success: _propTypes.default.func.isRequired,
  onAuthenticate: _propTypes.default.func,
  onAuthFailed: _propTypes.default.func,
  createPicker: _propTypes.default.func,
  multiselect: _propTypes.default.bool,
  navHidden: _propTypes.default.bool,
  disabled: _propTypes.default.bool,
  extensions: _propTypes.default.array,
  query: _propTypes.default.string
};
GoogleChooser.defaultProps = {
  children: null,
  onAuthenticate: function onAuthenticate() {},
  onAuthFailed: function onAuthFailed() {},
  scope: ["https://www.googleapis.com/auth/drive"],
  viewId: "DOCS",
  authImmediate: false,
  origin: null,
  multiselect: false,
  createPicker: null,
  navHidden: false,
  disabled: false,
  extensions: [],
  query: ""
};
var _default = GoogleChooser;
exports.default = _default;